import React from 'react';

import axios from 'axios';

import {token, host} from '../../assets/options';

class MobileCategories extends React.Component {
    _isMounted = false;
    constructor(props){
        super(props);

        this.state = {
            categories: []
        }

        this.allow = true;
    }
    componentDidMount(){
        this._isMounted = true;

        function check(x) {
            if (x.matches && this.allow) {
                axios.post(host + '/api/garden/category', {}, {headers: {'authorization': token}})
                .then(res => {
                    if (res.status === 200) {
                        if(this._isMounted)
                            this.setState({
                                categories: res.data.data
                            });

                        this.allow = false;

                        this.getData('', 'Բոլորը');
                    } else {
                    const error = new Error(res.data.error);
                    throw error;
                    }
                })
                .catch(err => {
                    console.error(err.response?err.response.data.error:err);
                }); 
            }
        }
          
        var media = window.matchMedia("(max-width: 1024px)")
        check.bind(this)(media);
        media.addListener(check.bind(this));
    }
    componentWillUnmount(){
        this._isMounted = false;
    }
    getData(id, name){
        this.props.this.getData(id, name);
    }
    onChange(el){
        this.getData(el.value, (el.value !== '')?(this.state.categories.find(category=>{if(category._id === el.value) return true})).name:'Բոլորը')
    }
    render(){
        return(
            <div className="MobileCategoriesContainer">
                <select name="cars" defaultValue="" onChange={(e)=>this.onChange(e.target)} className="selectpicker" id="cars">
                    <option value="">Բոլորը</option>
                    {this.state.categories.map(category=>{
                        return <option key={category._id} value={category._id}>{category.name}</option>
                    })}
                </select>
            </div>    
        );
    }
}

export default MobileCategories;